import styled from 'vue-styled-components'

const CircleBtn = styled('div', {
  width: {
    type: String,
    default: '48px',
  },
})`
  width: ${(props) => props.width};
  height: ${(props) => props.width};
  border-radius: 50%;
  background: var(--noticeBg);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0px 0px 40px 0px var(--bigShadow);
  svg {
    color: #9d9d9d;
  }
  &:hover {
    background: var(--bgGreen);
    svg {
      color: var(--memberPlanColor);
    }
  }
`

export { CircleBtn }
